import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import useDish from '../features/DishContainer/hooks/useDish';
import useCreatePpsi from '../features/PpsiContainer/hooks/useCreatePpsi';
import usePpisRelatedToFormulaCode from '../features/PpiContainer/hooks/usePpisRelatedToFormulaCode';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import useQueryParams from '../utils/useQueryParams';
import {
  getConfigs,
  getAvailableLanguages,
  getLanguage
} from '../features/app/selectors';
import { getPpsiDefaultData } from '../features/PpsiContainer/util';
import { getIsGlobalUser } from '../features/loginSystem/selectors';
import PpsiForm from '../components/PpsiForm';
import { ppsiInProgressRoute } from '../routes';

import { Mode } from '../components/PpsiForm/constants';
import View from './views';

import useMarketDishLogo from 'features/PpsiContainer/hooks/useMarketDishLogo';
//import useProductAreas from 'features/PpsiContainer/hooks/useProductAreas';
import useProductArea from 'features/DishContainer/hooks/useProductArea';

const PpsiCreateView = () => {
  const [formulaCode] = useQueryParams('formulaCode');
  let actionType="create"
  const [dish, isFetching] = useDish(formulaCode, actionType, { forceFetch: true });
  const [isFetchingPpisRelatedToFormula] = usePpisRelatedToFormulaCode(
    formulaCode
  );
  const [isFetchingLogo, marketDishLogo, fetchError] = useMarketDishLogo({
    forceFetch: true
  });
   const [isFetchingProductArea, productArea, fetchProductAreaError] = useProductArea({
    forceFetch: true
  });
  const [createPpsi, isSaving, createdPpsiId] = useCreatePpsi();
  const languages = useSelector(getAvailableLanguages);
  const getConfigData = useSelector(getConfigs).toJS();
  const isGlobalUser = useSelector(getIsGlobalUser);
  const language = useSelector(getLanguage);
  //const [piaProductAreas] = useProductAreas();

  // Initiate sales area code and stoe code
  const storeLists = isGlobalUser
    ? []
    : getConfigData && getConfigData.stores.map(item => item.code);
  const salesAreas =
    getConfigData && getConfigData.salesPoint.map(item => item.code);

  // Initiate fetching of utensils
  useUtensils();
  useGlobalPpis();

  // Redirect, if created
  if (createdPpsiId) {
    return <Redirect to={ppsiInProgressRoute(createdPpsiId)} />;
  }

  // Render spinner
  if (isFetching || isFetchingPpisRelatedToFormula || isFetchingLogo) {
    return <ProgressFullscreen open />;
  }

  function handleCreate(data, callback) {
    createPpsi(data, callback);
  }
  const defaultData = getPpsiDefaultData(
    languages,
    dish,
    storeLists,
    salesAreas
  );

  View.PpsiCreate.visit(dish, language);

  return (
    <PpsiForm
      defaultData={defaultData}
      isSaving={isSaving}
      dataLabels={{
        title: `dish.presentationName.${language}`
      }}
      mode={Mode.CREATE}
      onSave={handleCreate}
      //piaProductAreas={piaProductAreas}
    />
  );
};

export default PpsiCreateView;
